import React, { useState, useEffect, useRef } from "react";
import "./MobileCategoryOverlay.css";
import axios from "axios";
import { Api } from "../../BackendApi/api";
import { useNavigate } from "react-router-dom";
import MobileConfirmPopup from "../../Component/MobileConfirmPopup/MobileConfirmPopup";

const MobileCategoryOverlay = ({ onClose, onSave }) => {
  const [categoryName, setCategoryName] = useState("");
  const [description, setDescription] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [popup, setPopup] = useState({
    show: false,
    message: "",
    type: "success",
  });

  const navigate = useNavigate();
  const nameInputRef = useRef(null);

  // ✅ Focus fix — ensure it happens after full mount
  useEffect(() => {
    const timer = setTimeout(() => {
      if (nameInputRef.current) {
        nameInputRef.current.focus();
      }
    }, 100); // slight delay ensures DOM is ready
    return () => clearTimeout(timer);
  }, []);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        setPopup({
          show: true,
          message: "Please login first!",
          type: "warning",
        });
        setLoading(false);
        return;
      }

      const payload = {
        CategoryName: categoryName,
        Description: description,
        CategoryImagePath: selectedImage
          ? `/images/categories/${selectedImage.name}`
          : "",
      };

      const res = await axios.post(Api.addCategory, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (
        res.data.status === 0 &&
        (res.data.message === "Invalid AuthToken" ||
          res.data.message === "AuthToken is required")
      ) {
        navigate("/");
        return;
      }

      setPopup({
        show: true,
        message: res.data.message || "Category added successfully!",
        type: "success",
      });
    } catch (err) {
      console.error(err);
      setPopup({
        show: true,
        message: err.response?.data?.message || "Failed to add category",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handlePopupClose = () => {
    setPopup({ ...popup, show: false });
    if (popup.type === "success") {
      if (onSave) onSave();
      onClose();
    }
  };

  return (
    <div className="mobile-category-overlay">
      <div className="mobile-category-overlay-content">
        <h2>Add Category</h2>
        <form className="mobile-category-overlay-form" onSubmit={handleSubmit}>
          <label>
            Category Name
            <input
              ref={nameInputRef}
              type="text"
              value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)}
              required
            />
          </label>

          <label>
            Description
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            ></textarea>
          </label>

          <label>
            Upload Image
            <input type="file" accept="image/*" onChange={handleImageChange} />
          </label>

          {preview && (
            <div className="mobile-category-image-preview">
              <img src={preview} alt="Preview" />
            </div>
          )}

          <div className="mobile-category-overlay-buttons full-width">
            <button type="button" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" disabled={loading}>
              {loading ? "Saving..." : "Save"}
            </button>
          </div>
        </form>
      </div>

      <MobileConfirmPopup
        show={popup.show}
        message={popup.message}
        type={popup.type}
        onClose={handlePopupClose}
      />
    </div>
  );
};

export default MobileCategoryOverlay;
